/* ============================================================
   Silver & Co — capa de analítica
   Un solo lugar donde se disparan los eventos de ecommerce.
   Los destinos se configuran en window.SILVER_ANALYTICS:
     { ga4:'G-XXXX', pixel:'1234567890', endpoint:'https://...', debug:false }
   Cualquiera puede quedar vacío. Si no hay ninguno, no hace nada.
   ============================================================ */
(function () {
  const cfg = window.SILVER_ANALYTICS || {};
  const activo = !!(cfg.ga4 || cfg.pixel || cfg.endpoint);
  const log = (...a) => cfg.debug && console.log('[analitica]', ...a);

  /* ---------- carga de scripts de terceros ---------- */
  function cargar(src) {
    const s = document.createElement('script');
    s.async = true; s.src = src;
    document.head.appendChild(s);
  }

  if (cfg.ga4) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    gtag('js', new Date());
    gtag('config', cfg.ga4, { send_page_view: true, currency: 'PYG' });
    cargar('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(cfg.ga4));
  }

  if (cfg.pixel) {
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = true; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', cfg.pixel);
    fbq('track', 'PageView');
  }

  /* ---------- mapeo de eventos ----------
     Un solo evento nuestro se traduce al nombre que espera cada destino.
     GA4 usa snake_case; Meta usa PascalCase. Los nombres no son
     intercambiables: si se manda el equivocado, el evento entra pero
     no cuenta como conversión.                                        */
  const MAPA = {
    ver_producto:     { ga4: 'view_item',        meta: 'ViewContent' },
    ver_lista:        { ga4: 'view_item_list',   meta: null },
    agregar_carrito:  { ga4: 'add_to_cart',      meta: 'AddToCart' },
    quitar_carrito:   { ga4: 'remove_from_cart', meta: null },
    ver_carrito:      { ga4: 'view_cart',        meta: null },
    iniciar_checkout: { ga4: 'begin_checkout',   meta: 'InitiateCheckout' },
    buscar:           { ga4: 'search',           meta: 'Search' },
    comprar:          { ga4: 'purchase',         meta: 'Purchase' }
  };

  /* monto() solo redondea: GA4 y Meta esperan el valor en la moneda,
     no en subunidades. La conversión se hace en cada punto de llamada,
     porque las dos fuentes de Shopify no coinciden:
       · Ajax Cart API  → enteros en subunidades  ⇒ hay que dividir /100
       · Web Pixels     → decimales ya en moneda  ⇒ NO dividir
     Dividir donde no corresponde deja los ingresos cien veces más chicos
     (o más grandes), y en guaraníes el error pasa desapercibido un buen rato. */
  const monto = n => Math.round(Number(n) || 0);

  function itemsGA4(items) {
    return (items || []).map(i => ({
      item_id: i.sku, item_name: i.nombre, item_category: i.categoria,
      item_variant: i.variante, price: monto(i.precio), quantity: i.cantidad || 1
    }));
  }

  function evento(nombre, datos) {
    if (!activo) return;
    datos = datos || {};
    const m = MAPA[nombre];
    if (!m) { log('evento desconocido:', nombre); return; }
    log(nombre, datos);

    if (cfg.ga4 && m.ga4) {
      const p = { currency: 'PYG' };
      if (datos.valor != null) p.value = monto(datos.valor);
      if (datos.items) p.items = itemsGA4(datos.items);
      if (datos.lista) p.item_list_name = datos.lista;
      if (datos.termino) p.search_term = datos.termino;
      if (datos.pedido) p.transaction_id = datos.pedido;
      if (datos.envio != null) p.shipping = monto(datos.envio);
      gtag('event', m.ga4, p);
    }

    if (cfg.pixel && m.meta) {
      const p = { currency: 'PYG' };
      if (datos.valor != null) p.value = monto(datos.valor);
      if (datos.items) {
        p.content_type = 'product';
        p.contents = datos.items.map(i => ({ id: i.sku, quantity: i.cantidad || 1, item_price: monto(i.precio) }));
        p.content_ids = datos.items.map(i => i.sku);
        p.content_name = datos.items[0] && datos.items[0].nombre;
      }
      if (datos.termino) p.search_string = datos.termino;
      fbq('track', m.meta, p, datos.pedido ? { eventID: String(datos.pedido) } : undefined);
    }

    if (cfg.endpoint) {
      const cuerpo = JSON.stringify({
        evento: nombre, ts: Date.now(), url: location.href,
        ref: document.referrer || null, moneda: 'PYG', ...datos
      });
      try {
        if (navigator.sendBeacon) navigator.sendBeacon(cfg.endpoint, new Blob([cuerpo], { type: 'application/json' }));
        else fetch(cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: cuerpo, keepalive: true });
      } catch (e) { log('endpoint falló', e); }
    }
  }

  window.SilverAnalytics = { evento, activo, cfg };
})();
